import { render, staticRenderFns } from "./ShippingDetails.vue?vue&type=template&id=243abeee&"
import script from "./ShippingDetails.vue?vue&type=script&lang=js&"
export * from "./ShippingDetails.vue?vue&type=script&lang=js&"
import style0 from "./ShippingDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports